import { render, staticRenderFns } from "./CanvasImage.vue?vue&type=template&id=4f66fa78&"
import script from "./CanvasImage.vue?vue&type=script&lang=js&"
export * from "./CanvasImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports